export const getHost = () => window.location.hostname.replace("www.", "");
